import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20luxury%20lifestyle%20scene%20with%20high-end%20fashion%20items%20and%20beauty%20products%20arranged%20on%20minimal%20cream%20background%2C%20warm%20golden%20lighting%2C%20premium%20aesthetic%2C%20soft%20shadows%2C%20editorial%20style%20photography%2C%20sophisticated%20and%20refined%20atmosphere%2C%20neutral%20earth%20tones&width=1920&height=1080&seq=hero-main-01&orientation=landscape"
          alt="欧美精品 - 高端品质好物"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/35"></div>
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-semibold text-white mb-4 leading-tight">
          欧美精品
        </h1>
        <p className="text-base md:text-xl text-white/85 max-w-2xl mb-8 leading-relaxed">
          正品甄选·高端品质直达 —— 汇聚全球顶尖品牌，为您精选来自欧洲与美国的高端正品好物
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/categories"
            className="px-8 py-3 rounded-full bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            探索精选分类
          </Link>
          <Link
            to="/articles"
            className="px-8 py-3 rounded-full bg-white/20 text-white border border-white/30 text-sm font-medium hover:bg-white/30 transition-colors whitespace-nowrap"
          >
            阅读品牌资讯
          </Link>
        </div>
      </div>
    </section>
  );
}